export { default } from './components/ValueProposition'
